module.exports = __webpack_public_path__ + "img/insightful.744c0962.svg";